import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function animateAproposImage() {
  const container = document.querySelector("#apropos");

  if (!container) return; // Aucun bloc → on sort sans erreur

  const pics = container.querySelectorAll(".pic-container .wp-block-image");

  if (pics.length === 0) return; // Aucun élément à animer

  // Animation groupée dans une timeline synchronisée
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: "top center",
      toggleActions: "play none none none"
    }
  });

  // Pic 1 – entrée par le haut
  tl.from(pics[0], {
    y: -100,
    opacity: 0,
    duration: 0.8,
    ease: "power2.out"
  });

  // Pic 2 – entrée par le bas (si présent)
  if (pics[1]) {
    tl.from(pics[1], {
      y: 100,
      opacity: 0,
      duration: 0.8,
      ease: "power2.out"
    }, "<"); // "<" = commence en même temps que le précédent
  }
}
